import { graphql } from "../generated/gql";

export const CreateLayoutGQL = graphql(`
  mutation CreateLayout($input: CreateLayoutInput!) {
    createLayout(input: $input) {
      name
      id
      createdAt
      status
      projectId
    }
  }
`);
